import { render, staticRenderFns } from "./StockQuotations.vue?vue&type=template&id=030aa744"
import script from "./StockQuotations.vue?vue&type=script&lang=js"
export * from "./StockQuotations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports